import { v4ExtendedPalette } from './v4/extended-palette';

export const palette = {
  v4: v4ExtendedPalette,
};
